// GraphQL fields that carry purchasing, packaging or components cost; all are nullable Floats.
export const COST_KEYS: ReadonlySet<string> = new Set([
  'cost',
  'purchasingCost',
  'packagingCost',
  'componentsCost',
  'foodCost',
  'totalLeftoverCost'
]);

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !(value instanceof Date);

// A copy of `value` with every cost field at any depth set to null.
export const withoutCosts = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(withoutCosts);
  }
  if (!isRecord(value)) {
    return value;
  }
  return Object.fromEntries(
    Object.entries(value).map(([key, entry]) => [key, COST_KEYS.has(key) ? null : withoutCosts(entry)])
  );
};
